import { render, staticRenderFns } from "./AddEditParkingArea.vue?vue&type=template&id=47279f56"
import script from "./AddEditParkingArea.vue?vue&type=script&lang=js"
export * from "./AddEditParkingArea.vue?vue&type=script&lang=js"
import style0 from "./AddEditParkingArea.vue?vue&type=style&index=0&id=47279f56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports